import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Globe, ArrowRight, ShieldCheck, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const [subdomain, setSubdomain] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    const sub = subdomain.toLowerCase().trim();
    if (!sub.match(/^[a-z0-9-]{3,30}$/)) {
      return toast.error("Enter a valid subdomain (3-30 chars, letters/numbers/-)");
    }
    nav(`/t/${sub}/login`);
  };

  return (
    <div data-testid="login-page" className="min-h-[calc(100vh-5rem)] grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-[#1B4332] overflow-hidden">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#52B788]/30 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-[#FFE4E8]/10 blur-3xl" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <Link to="/" className="flex items-center gap-2 text-white/80 hover:text-white text-sm">
            <ArrowLeft size={16} /> Back to brivo360.com
          </Link>
          <div>
            <h2 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
              "Brivo360 replaced 4 separate tools we were paying for. Sales jumped 32% in two months."
            </h2>
            <div className="mt-8 flex items-center gap-3">
              {/* <img src="https://images.unsplash.com/photo-1758887261865-a2b89c0f7ac5?crop=entropy&cs=srgb&fm=jpg&q=85&w=200" alt="" className="w-12 h-12 rounded-full object-cover" /> */}
              <div>
                <div className="font-semibold">Adaeze Okonkwo</div>
                <div className="text-sm text-white/60">Founder, Link Beauty</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 lg:p-16 bg-[#FFFCF2]">
        <div className="w-full max-w-md">
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-black tracking-tight">Find your business</h1>
          <p className="mt-3 text-black/70">Enter your Brivo360 subdomain to continue to your workspace login.</p>

          <form onSubmit={onSubmit} className="mt-9 space-y-4">
            <div>
              <label className="text-sm font-semibold text-black mb-2 block">Workspace subdomain</label>
              <div className="flex items-stretch rounded-xl border border-black/15 focus-within:border-[#1B4332] bg-white overflow-hidden">
                <span className="flex items-center pl-4 pr-2 text-black/40"><Globe size={16} /></span>
                <input
                  data-testid="workspace-picker-input"
                  value={subdomain}
                  onChange={(e) => setSubdomain(e.target.value)}
                  placeholder="your-company"
                  autoFocus
                  className="flex-1 px-2 py-3 focus:outline-none bg-white"
                />
                <span className="flex items-center px-3 bg-[#FFFCF2] text-black/60 text-sm border-l border-black/10">.brivo360.com</span>
              </div>
            </div>
            <button
              data-testid="workspace-picker-submit"
              type="submit"
              className="btn-primary w-full justify-center mt-2"
            >
              Continue <ArrowRight size={16} />
            </button>
          </form>

          <div className="mt-6 text-sm text-center text-black/70">
            Don't have account yet? <Link to="/register" className="font-semibold text-[#1B4332] hover:underline">Create one free</Link>
          </div>

          {/* <div className="mt-8 pt-6 border-t border-black/10 text-center">
            <Link to="/admin/login" data-testid="admin-portal-link" className="inline-flex items-center gap-1.5 text-xs text-black/50 hover:text-black">
              <ShieldCheck size={12} /> Master admin portal
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
}
